import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const roleHome = (user) => {
  if (!user) return "/login";
  if (user.role === "admin") return "/admin";
  if (user.role === "merchant") return "/loja";
  if (user.role === "courier") return "/entregas";
  return "/";
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [city, setCity] = useState(null);
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCity(data.city);
      setStore(data.store);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("gf_token")) load();
    else {
      setUser(false);
      setLoading(false);
    }
  }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gf_token", data.token);
    await load();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("gf_token", data.token);
    await load();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("gf_token");
    setUser(false);
    setCity(null);
    setStore(null);
  };

  return (
    <AuthContext.Provider value={{ user, city, store, loading, login, register, logout, refresh: load }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
